var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.199 141.477C181.222 141.109 180.466 140.748 179.4 140.572C179.361 139.491 179.1 138.694 178.733 138.67C178.367 138.647 178.007 139.401 177.831 140.465C176.711 140.494 175.876 140.76 175.852 141.137C175.828 141.512 176.619 141.881 177.722 142.052C177.752 143.17 178.017 144.003 178.392 144.027C178.768 144.051 179.137 143.255 179.308 142.146C180.384 142.105 181.176 141.843 181.199 141.477Z",
    fill: "#3F3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.614 20.4054C163.085 19.8504 163.104 18.972 163.658 18.4432C164.212 17.9144 165.091 17.9356 165.62 18.4906C166.15 19.0455 166.13 19.924 165.576 20.4528C165.022 20.9816 164.144 20.9603 163.614 20.4054Z",
    fill: "#3F3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.388 34.6312C175.677 34.9334 176.558 34.5808 177.524 33.828C178.455 34.6267 179.32 35.0215 179.622 34.7337C179.922 34.4465 179.571 33.5675 178.82 32.603C179.657 31.6477 180.077 30.748 179.781 30.4385C179.487 30.1297 178.572 30.505 177.581 31.2926C176.627 30.458 175.73 30.0388 175.422 30.3331C175.113 30.628 175.492 31.5469 176.285 32.5417C175.491 33.4688 175.101 34.3298 175.388 34.6312Z",
    fill: "#3F3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8665 17.1145C26.6136 17.5817 26.0303 17.7557 25.5639 17.5031C25.0975 17.2506 24.9245 16.667 25.1774 16.1998C25.4304 15.7326 26.0137 15.5586 26.4801 15.8112C26.9466 16.0639 27.1196 16.6473 26.8665 17.1145Z",
    fill: "#3F3D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2927 3.85746C41.48 3.51174 40.909 2.82372 39.9551 2.17642C40.4013 1.11134 40.5047 0.222259 40.1595 0.0352345C39.8152 -0.151246 39.1295 0.418275 38.4827 1.36988C37.3848 0.896666 36.4572 0.780746 36.2654 1.13491C36.074 1.48825 36.6749 2.1993 37.6671 2.85886C37.1955 3.95527 37.0796 4.88004 37.4324 5.07115C37.786 5.26267 38.4995 4.65705 39.1612 3.65886C40.2215 4.10143 41.106 4.20236 41.2927 3.85746Z",
    fill: "#3F3D3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9037 131.759C12.6799 131.099 13.0328 130.382 13.6921 130.159C14.3514 129.935 15.0672 130.289 15.291 130.95C15.5148 131.61 15.1619 132.327 14.5026 132.55C13.8433 132.774 13.1275 132.419 12.9037 131.759Z",
    fill: "#3F3D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4393 181.5C141.111 181.5 181.379 141.233 181.379 91.5609C181.379 41.8888 141.111 1.62158 91.4393 1.62158C41.7672 1.62158 1.5 41.8888 1.5 91.5609C1.5 141.233 41.7672 181.5 91.4393 181.5Z",
    fill: "#F3F7FE",
    stroke: "#F0F6FE",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.243 61L91.7 85.5426L67.1573 61L61 67.1573L85.5426 91.7L61 116.243L67.1573 122.313L91.7 97.7706L116.243 122.313L122.4 116.243L97.8573 91.7L122.4 67.1573L116.243 61Z",
    fill: "#76A6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelConfirmation);
export default __webpack_public_path__ + "static/media/CancelConfirmation.1f271ec570493021ed28dd8c3e1136ac.svg";
export { ForwardRef as ReactComponent };